import i18n from '@/utils/i18n';
import moment from 'moment-timezone';
import { EMPTY_VALUE_PLACEHOLDER } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { formatWeeklyValue } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/utils/prospect-value-utils';
import type {
  ManagerProspectQueryRow,
  ManagerProspectRowData,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

const daysSince = (isoDate: string): number =>
  Math.max(
    0,
    moment().startOf('day').diff(moment(isoDate).startOf('day'), 'days'),
  );

const formatDays = (days: number): string =>
  days === 0
    ? i18n.t('sales_portal.prospects.manager.today')
    : i18n.t('sales_portal.prospects.manager.days_short', { count: days });

export function transformToManagerProspectRowData(
  rows: ManagerProspectQueryRow[],
): ManagerProspectRowData[] {
  return rows.map((row) => {
    const daysSinceTouch = row.last_activity_at
      ? daysSince(row.last_activity_at)
      : undefined;

    return {
      daysSinceTouch,
      daysSinceTouchDisplay:
        daysSinceTouch === undefined
          ? EMPTY_VALUE_PLACEHOLDER
          : formatDays(daysSinceTouch),
      name: row.restaurant_name,
      prospectUUID: row.uuid,
      repName: row.owned_by_name ?? EMPTY_VALUE_PLACEHOLDER,
      repUUID: row.owned_by_id ?? undefined,
      restaurantUUID: row.restaurant_id,
      stage: row.stage,
      supplierUUID: row.supplier_id,
      weeklyValueDisplay: formatWeeklyValue(
        row.weekly_estimated_value_in_micros,
        row.currency_code,
      ),
      weeklyValueInMicros: row.weekly_estimated_value_in_micros ?? undefined,
    };
  });
}
